import { ArrowRight } from "lucide-react";
import { Badge } from "../../components/Badge/Badge";
import styles from "./UsersPage.module.css";

interface Props {
  /** Direction of the role transition. */
  from: "super_admin" | "project_user";
  to: "super_admin" | "project_user";
}

function label(role: "super_admin" | "project_user"): string {
  return role === "super_admin" ? "Super admin" : "Member";
}

function variant(role: "super_admin" | "project_user"): "admin" | "user" {
  return role === "super_admin" ? "admin" : "user";
}

/**
 * Visual `Member → Super admin` / `Super admin → Member` transition used in
 * Promote and Demote modals. Mockup L511-L515.
 */
export function RoleArrow({ from, to }: Props) {
  return (
    <div className={styles.roleArrow}>
      <Badge variant={variant(from)}>{label(from)}</Badge>
      <ArrowRight
        size={16}
        aria-hidden="true"
        className={styles.roleArrowGlyph}
      />
      <Badge variant={variant(to)}>{label(to)}</Badge>
    </div>
  );
}
